import React from "react";

export default class TextNumberInput extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            value: this.props.value
        }
    }

    handleChange(event) {
        this.setState({value: event.target.value});
        if (this.props.onChange)
            this.props.onChange(event.target.value)
    }


    render (){

        const passwordFlag = this.props.type != undefined ? this.props.type == "password" : false;
        const readOnly = this.props.readOnly != undefined && this.props.readOnly == true ? true : false;

        if (readOnly == true){
            return (<div style={mainClass}>
                <div style={name}>{this.props.name}</div>
                <input type={"number"} style={{...inputTextDisabled, borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey', backgroundColor: '#EEEEEE', ...this.props.inputStyle}} readOnly value={this.state.value ? this.state.value : this.props.value} onChange={this.handleChange.bind(this)}></input>
            </div>
            );
        }

        return ( 
        <div style={mainClass}>
            <div style={name}>{this.props.name}</div>
            <input type={"number"} placeholder={ this.props.placeholder ? this.props.placeholder : '' } style={{...inputText, borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey', backgroundColor: '#EEEEEE', ...this.props.inputStyle}} min={this.props.minValue} max={this.props.maxValue}  value={this.state.value ? this.state.value : this.props.value} onChange={this.handleChange.bind(this)}></input>
        </div>
        )
    }


}

const mainClass = {
    padding: '5px',
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}